import { EIREntry, MedicalTerm } from '../types';

// Date formatting
export const formatDate = (dateString: string): string => {
  if (!dateString || dateString.trim() === '') return 'Unknown Date';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('sv-SE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    return dateString;
  }
};

// Medical term explanations
export const findMedicalExplanationsForEntry = (
  entry: EIREntry,
  medicalTerms: Record<string, string>
): MedicalTerm[] => {
  if (!medicalTerms || Object.keys(medicalTerms).length === 0) return [];

  const parts: string[] = [];
  if (entry.category) parts.push(entry.category);
  if (entry.type) parts.push(entry.type);
  if (entry.status) parts.push(entry.status);
  if (entry.content?.summary) parts.push(entry.content.summary);
  if (entry.content?.details) parts.push(entry.content.details);
  if (entry.content && Array.isArray(entry.content.notes)) parts.push(entry.content.notes.join(' '));

  const haystack = parts.join(' ').toLowerCase();
  const matches = new Map<string, string>();

  for (const term of Object.keys(medicalTerms)) {
    const termLower = term.toLowerCase();
    if (haystack.includes(termLower)) {
      if (!matches.has(term)) {
        matches.set(term, medicalTerms[term]);
      }
    }
  }

  return Array.from(matches.entries()).map(([term, explanation]) => ({ term, explanation }));
};

// Filter entries
export const filterEntries = (entries: EIREntry[], filters: any): EIREntry[] => {
  return entries.filter(entry => {
    // Category filter
    if (filters.category && entry.category !== filters.category) return false;

    // Provider filter
    if (filters.provider && entry.provider?.name !== filters.provider) return false;

    // Status filter
    if (filters.status && entry.status !== filters.status) return false;

    // Date range filter
    if (filters.startDate && entry.date && entry.date < filters.startDate) return false;
    if (filters.endDate && entry.date && entry.date > filters.endDate) return false;

    // Search filter
    if (filters.searchTerm) {
      const searchableText = [
        entry.category,
        entry.type,
        entry.provider?.name,
        entry.content?.summary,
        entry.content?.details
      ].join(' ').toLowerCase();

      if (!searchableText.includes(filters.searchTerm.toLowerCase())) return false;
    }

    return true;
  });
};
